import api from '@/api';

const store = {
  state: {},

  mutations: {},

  getters: {},

  actions: {
    async menuUploadAction({ commit }, payload) {
      try {
        const { data } = await api.uploadMenuList(payload);
        return data;
      } catch (e) {
        return e;
      }
    }
  }
};

export default store;
